import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Button, CustomSelect } from "../../components";
import { updateOrganization } from "@/store/constants/constants.action";
import { connect, ConnectedProps } from "react-redux";
import { RootState } from "../../store";

interface AddOrganizationFormProps {
  onClose: () => void;
  organization: any;
}

export const EditOrgForm = ({
  onClose,
  organization,
  updateOrganization,
}: Props) => {
  const formik = useFormik({
    initialValues: {
      name: organization?.name,
      desc: organization?.desc,
      status: organization?.status,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Organization Name is required"),
      desc: Yup.string().required("Organization Description is required"),
    }),
    onSubmit: (values) => {},
  });

  const handleSubmit = (values: any) => {
    updateOrganization({ ...values, id: organization?.id });
    onClose();
  };

  return (
    <form onSubmit={formik.handleSubmit} className="p-3">
      <div className="mb-3">
        <label htmlFor="organizationName" className="form-label">
          Organization Name
        </label>
        <input
          id="organizationName"
          name="name"
          type="text"
          className={`form-control ${
            formik.touched.name && formik.errors.name ? "is-invalid" : ""
          }`}
          value={formik.values.name}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        {formik.touched.name && formik.errors.name ? (
          <div className="invalid-feedback">{}</div>
        ) : null}
      </div>
      <div className="mb-3">
        <label htmlFor="organizationDescription" className="form-label">
          Organization Description
        </label>
        <textarea
          id="organizationDescription"
          name="desc"
          className={`form-control ${
            formik.touched.desc && formik.errors.desc ? "is-invalid" : ""
          }`}
          value={formik.values.desc}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        {formik.touched.desc && formik.errors.desc ? (
          <div className="invalid-feedback">{}</div>
        ) : null}
      </div>
      <CustomSelect
        className="mb-3"
        value={formik.values.status}
        label="Status"
        name="status"
        options={[
          { label: "Active", value: 1 },
          { label: "Inactive", value: 2 },
        ]}
        disabled={false}
        placeholder="Select Status"
        handleChange={(newValue: any) => {
          formik.setFieldValue("status", newValue.value);
        }}
      />

      <div className="d-flex justify-content-end">
        <Button type="outline-secondary" onClick={onClose} className="me-2">
          Cancel
        </Button>
        <Button type="primary" onClick={() => handleSubmit(formik.values)}>
          Save
        </Button>
      </div>
    </form>
  );
};

const mapState = (state: RootState) => ({});
const mapDispatch = {
  updateOrganization,
};

const connector = connect(mapState, mapDispatch);
type Props = ConnectedProps<typeof connector> & AddOrganizationFormProps;

export default connector(EditOrgForm);
